import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import loadScript from 'lib/loadScript';
import styles from './styles.module.scss';

/**
 * Maps state to props
 *
 * @param {object} state
 * @param {object} state.router
 */
const mapStateToProps = ({ router }) => ({
  domain: router.domain,
});

/**
 * Renders a Newsvine poll
 *
 * @param {object} props
 * @param {string} props.baseline
 * @param {string} props.domain
 * @returns {React.JSX.Element|boolean}
 */
const NewsvinePoll = ({ baseline, domain }) => {
  useEffect(() => {
    /**
     * Helper function to load scripts
     */
    const loadPollScripts = async () => {
      await loadScript('//code.jquery.com/jquery-2.2.4.min.js');

      // Jenga bootstrap
      await loadScript(`//nvcdn.${domain || 'nbcnews.com'}/_elliott/jenga?widgets=newsletter`);

      const loader = new window.$j.ModuleLoader('polls');

      loader.loadCSS = false;
    };

    loadPollScripts();
  }, [domain]);

  const pollClick = useCallback((e) => {
    if (e.target && e.target.tagName === 'INPUT') {
      const c = 'checked';
      const t = e.target;
      // Remove checked class.
      const l = t.parentNode.parentNode.querySelectorAll('label');
      for (let n = 0; n < l.length; n += 1) {
        if (l[n].classList) {
          l[n].classList.remove(c);
        } else {
          l[n].className = l[n].className.replace(c, '');
        }
      }
      // Add Checked class.
      t.parentNode.className += ` ${c}`;
    }
  }, []);

  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <div className={styles.container} data-testid="newsvine-poll">
      <div
        className={styles.pollWrapper}
        dangerouslySetInnerHTML={{ __html: baseline }}
        onClick={(e) => pollClick(e)}
      />
    </div>
  );
};

export default connect(mapStateToProps)(NewsvinePoll);

